export const GET_TYPES = 'GET_TYPES';
export const GET_TYPE = 'GET_TYPE';
